import React, { FC, Fragment, useEffect, useState } from "react";
import CommentListing from "components/CommentListing/CommentListing";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import Badge from "shared/Badge/Badge";
import StayDatesRangeInput from "./StayDatesRangeInput";
import { useLocation, useNavigate } from "react-router-dom";
import { Amenities_demos, amenities_hoteles } from "./constant";
import { Dialog, Transition } from "@headlessui/react";
import { ArrowRightIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import ButtonCircle from "shared/Button/ButtonCircle";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import DetailPagetLayout from "../Layout";
import GuestsInput from "./GuestsInput";
import config from "config.json";
import useFetch from "hooks/useFetch";
import ReservationModal from "components/Modal/reservationModal";
import ErrorModal from "components/Modal/errorModal";
import SuccessModal from "components/Modal/successModal";
import LoginModal from "components/Modal/loginModal";
import { useHotelPhotos } from "./useHotelPhotos";


interface Amenity {
  name: string;
  icon: string;
}

// Define el tipo de cada hotel
interface Hotel {
  nombre: string;
  amenities: Amenity[];
}

const StayDetailPageContainer: FC<{}> = () => {
  useEffect(() => {
    sessionStorage.removeItem("dates_adjusted");
  }, []);

  const PHOTOS = useHotelPhotos();
  const formatDate = (dateString?: string): string => {
    // Helper function to get the default date in YYYY-MM-DD format
    const getDefaultDate = (offsetDays: number = 0) => {
      const date = new Date();
      date.setDate(date.getDate() + offsetDays);
      return date.toISOString().split('T')[0];
    };

    // Retrieve dates from sessionStorage
    let startDisp = sessionStorage.getItem("start_disp");
    let endDisp = sessionStorage.getItem("end_disp");

    // Set default dates if they do not exist
    if (!startDisp) {
      startDisp = getDefaultDate(); // Today's date
      sessionStorage.setItem("start_disp", startDisp);
    }

    if (!endDisp) {
      endDisp = getDefaultDate(3); // Today's date plus 3 days
      sessionStorage.setItem("end_disp", endDisp);
    }

    // Use the provided dateString if available, otherwise use startDisp or endDisp
    const dateToFormat = dateString || startDisp || endDisp;

    // Function to parse date in MM/DD/YYYY format
    const parseMMDDYYYY = (date: string) => {
      const [month, day, year] = date.split('/').map(part => part.padStart(2, '0'));
      return new Date(`${year}-${month}-${day}`);
    };

    // Function to parse date in YYYY-MM-DD format
    const parseYYYYMMDD = (date: string) => {
      return new Date(date);
    };

    // Determine which format the input is in and parse accordingly
    let parsedDate: Date;
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateToFormat)) {
      // YYYY-MM-DD format
      parsedDate = parseYYYYMMDD(dateToFormat);
    } else if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateToFormat)) {
      // MM/DD/YYYY format with single-digit month or day
      parsedDate = parseMMDDYYYY(dateToFormat);
    } else {
      console.error('Formato de fecha no válido:', dateToFormat);
      return ''; // Return an empty string or handle as needed
    }

    // Check if the date is valid
    if (isNaN(parsedDate.getTime())) {
      console.error('Fecha no válida:', dateToFormat);
      return ''; // Return an empty string or handle as needed
    }

    return parsedDate.toISOString().split('T')[0];
  };

  const hotel_code = sessionStorage.getItem("selected_hotel") ? sessionStorage.getItem("selected_hotel") : new URLSearchParams(window.location.search).get('hotel');

  const selectedHotel = sessionStorage.getItem('selected_hotel') || "Default";
  const hotelamenities = amenities_hoteles.find((h: Hotel) => h.nombre === selectedHotel) || amenities_hoteles.find((h: Hotel)  => h.nombre === "Default");

  const [hotel, setHotel] = useState({} as any);

  const { data, isLoading, error, fetchData: fetchHotel } = useFetch('GET', `${config.backend_url}/setia/hotel/detalle?codigo=${hotel_code}`, { 'Content-Type': 'application/json' })

  interface FechasContingente {
    id: number;
    cod_hotel: string;
    fecha_inicio: string;
    fecha_fin: string;
  }

  const [fechasContingentes, setFechasContingentes] = useState<FechasContingente[]>([])

  const obtenerDiasMinimos = async() => {
    const response = await fetch(`${config.backend_url}/setia_administrator/dias_minimos/calcular`,{
      method: 'POST',
      headers:{
        'Content-Type': 'application/json',
      },
      body:JSON.stringify({
          "codigoHotel": hotel_code,
          "fechaDesde": sessionStorage.getItem("start_disp"),
          "fechaHasta": sessionStorage.getItem("end_disp"),
      })
    })

    if(!response.ok){
      throw new Error('Error al verificar los dias minimos');
    }

    const data = await response.json();

    return Number(data.description)
  }

  const obtenerDiasDeLasReservas = () =>{
    const inicio = new Date(sessionStorage.getItem("start_disp") as string);
    const fin = new Date(sessionStorage.getItem("end_disp") as string);

    // Calcular la diferencia en milisegundos
    const diferenciaMilisegundos = fin.getTime() - inicio.getTime();

    // Convertir la diferencia de milisegundos a días 
    const diferenciaDias = (diferenciaMilisegundos / (1000 * 60 * 60 * 24) );

    return diferenciaDias
  }

  const { 
    data:dataFechasContingentes, 
    isLoading: loadingFechasContingentes, 
    error: errorFechasContingentes, 
    fetchData: fetchFechasContingentes}
    = useFetch(
      'GET',
      `${config.backend_url}/setia_administrator/bloques/get_no_auth?cod_hotel=${hotel_code}`,
      null,
      { }
  )

  useEffect(() => {
    if(dataFechasContingentes){
      setFechasContingentes(dataFechasContingentes as FechasContingente[]);

      //agrego en el sessionStorage las fechas contingentes para el caso mobile
      sessionStorage.setItem('fechasContingentes', JSON.stringify(dataFechasContingentes));
    }

    if (errorFechasContingentes) {
      console.log(errorFechasContingentes);
    }
  }, [dataFechasContingentes, errorFechasContingentes])
  
  

  useEffect(() => {
    fetchHotel()
    fetchFechasContingentes()
    return () => {
      //elimino de sessionStorage las fechas contingentes para el caso mobile al pasar a otra pagina
      sessionStorage.removeItem('fechasContingentes');
    }
  }, [])

  useEffect(() => {
    if (data) {
      const response = data as any
      setHotel(response);
    }
    if (error) {
      console.log(error)
    }
  }, [data])

  let [isOpenModalAmenities, setIsOpenModalAmenities] = useState(false);

  const thisPathname = useLocation().pathname;
  const router = useNavigate();

  function closeModalAmenities() {
    setIsOpenModalAmenities(false);
  }

  function openModalAmenities() {
    setIsOpenModalAmenities(true);
  }

  const handleOpenModalImageGallery = () => {
    router('/listing-stay-detail/?modal=PHOTO_TOUR_SCROLLABLE');
  };

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap !space-y-6">
        {/* 1 */}
        <div className="flex justify-between items-center">
          {/* <Badge name="Wooden house" /> */}
          {/* <LikeSaveBtns /> */}
        </div>

        {/* 2 */}
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold">
          {hotel?.descripcion}
        </h2>

        {/* 3 */}
        <div className="flex items-center space-x-4">
          {/* <StartRating /> */}
          {/* <span>·</span> */}
          <span>
            <i className="las la-map-marker-alt"></i>
            <span className="ml-1"> {hotel?.ciudad}</span>
          </span>
        </div>

        {/* 5 */}
        <div className="w-full border-b border-neutral-100 dark:border-neutral-700" />

        {/* 6 */}
        <div className="flex items-center justify-between xl:justify-start space-x-8 xl:space-x-12 text-sm text-neutral-700 dark:text-neutral-300">
          <div className="flex items-center space-x-3 ">
            <i className=" las la-user text-2xl "></i>
            <span className="">
              {hotel?.cant_lugares} <span className="hidden sm:inline-block">huespedes</span>
            </span>
          </div>
          {/* <div className="flex items-center space-x-3">
            <i className=" las la-bed text-2xl"></i>
            <span className=" ">
              6 <span className="hidden sm:inline-block">beds</span>
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className=" las la-bath text-2xl"></i>
            <span className=" ">
              3 <span className="hidden sm:inline-block">baths</span>
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className=" las la-door-open text-2xl"></i>
            <span className=" ">
              2 <span className="hidden sm:inline-block">bedrooms</span>
            </span>
          </div> */}
        </div>
      </div>
    );
  };

  const renderSection2 = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Descripción del hotel</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="text-neutral-6000 dark:text-neutral-300">
          <span>
            {hotel?.texto_descripcion}
          </span>
        </div>
      </div>
    );
  };

  const renderSection3 = () => {
    return (
      <div className="listingSection__wrap">
        <div>
          <h2 className="text-2xl font-semibold">Servicios del hotel</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            {` Los servicios varian en función de las habilitaciones del hotel. `}
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* 6 */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
        {hotelamenities?.amenities.map((item) => (
        <div key={item.name} className="flex items-center space-x-3">
          <i className={`text-3xl las ${item.icon}`}></i>
          <span>{item.name}</span>
        </div>
      ))}
        </div>

        {/* ----- */}
        <div className="w-14 border-b border-neutral-200"></div>
        <div>
          <ButtonSecondary onClick={openModalAmenities}>
            Ver todos los servicios
          </ButtonSecondary>
        </div>
        {renderMotalAmenities()}
      </div>
    );
  };

  const renderMotalAmenities = () => {
    return (
      <Transition appear show={isOpenModalAmenities} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModalAmenities}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block py-8 h-screen w-full max-w-4xl">
                <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
                  <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                    <h3
                      className="text-lg font-medium leading-6 text-gray-900"
                      id="headlessui-dialog-title-70"
                    >
                      Todos los Servicios
                    </h3>
                    <span className="absolute left-3 top-3">
                      <ButtonClose onClick={closeModalAmenities} />
                    </span>
                  </div>
                  <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                  {hotelamenities?.amenities.map((item) => (
<div
key={item.name}
className="flex items-center py-2.5 sm:py-4 lg:py-5 space-x-5 lg:space-x-8"
>
<i
className={`text-4xl text-neutral-6000 las ${item.icon}`}
></i>
<span>{item.name}</span>
</div>
))}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  };

  const renderSection4 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Categorias </h2>
          {/* <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Los precios pueden cambiar en cualquier momento
          </span> */}
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* CONTENT */}
        <div className="flow-root">
          <div className="text-sm sm:text-base text-neutral-6000 dark:text-neutral-300 -mb-4">
            {/* <div className="flex space-x-10 justify-between p-3 my-3 bg-neutral-100 dark:bg-neutral-800 rounded-lg" >
              <span className="font-semibold">Tipo de habitación</span>
              <span className="font-semibold">Precio</span>
            </div> */}
            {hotel.categorias && hotel?.categorias.map((categoria: any) => (
              <div className="flex space-x-10 justify-between p-3 my-3 bg-neutral-100 dark:bg-neutral-800 rounded-lg" key={categoria.codigo}>
                <span>{categoria.descripcion}</span>
                {/* <span>${categoria.precio_promedio.toFixed(0)} por noche</span> */}
                <span>✅</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const renderMap = () => {
    return (
      <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3 ring-1 ring-black/10 rounded-xl z-0">
        <div className="rounded-xl overflow-hidden z-0">
          <iframe
            title="x"
            width="100%"
            height="100%"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBDLx574fc1sCwulPnoZ6Q_S3eriNm-V3Q&q=${hotel.latitud},${hotel.longitud}`}
          ></iframe>
        </div>
      </div>
    )
  }

  const renderSection7 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Ubicación del Hotel</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            {hotel?.direccion}, {hotel?.ciudad}
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* MAP */}
        {hotel && renderMap()}

      </div>

    );

  };

  const renderSection8 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Consideraciones Importantes</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        <div>
          <h4 className="text-lg font-semibold">Politica de Cancelación</h4>
          <span className="block mt-3 text-neutral-500 dark:text-neutral-400">
            {hotel?.texto_politica_cancelacion}
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        <div>
          <h4 className="text-lg font-semibold">Horarios Check-in y Check-out</h4>
          <div className="mt-3 text-neutral-500 dark:text-neutral-400 max-w-md text-sm sm:text-base">
            <div className="flex space-x-10 justify-between p-3 bg-neutral-100 dark:bg-neutral-800 rounded-lg">
              <span>Check-in</span>
              <span>{hotel?.checkin_time}</span>
            </div>
            <div className="flex space-x-10 justify-between p-3">
              <span>Check-out</span>
              <span>{hotel?.checkout_time}</span>
            </div>
          </div>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        <div>
          <h4 className="text-lg font-semibold">Notas Importantes</h4>
          <div className="prose sm:prose">
            <ul className="mt-3 text-neutral-500 dark:text-neutral-400 space-y-2">
              <li>
                {hotel?.nota_especial}
              </li>

            </ul>
          </div>
        </div>
      </div>
    );
  };

  let hotel_disp = sessionStorage.getItem("selected_hotel");
  let date_from_disp = sessionStorage.getItem("start_disp");
  let date_to_disp = sessionStorage.getItem("end_disp");
  let guest_disp = sessionStorage.getItem("total_disp");

  const [refresh, setRefresh] = useState(0);

  const { data: dataDisp, isLoading: loadingDisp, error: errorDisp, fetchData: fetchDisp } = useFetch('GET', `${config.backend_url}/setia/reservas/consultar?hotel=${hotel_code}&desde=${formatDate(date_from_disp ?? '')}&hasta=${formatDate(date_to_disp ?? '')}&cant_personas=${guest_disp}`, { 'Content-Type': 'application/json' })

  const [openModalReservation, setOpenModalReservation] = useState(false);
  const [openModalLogin, setOpenModalLogin] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [roomsData, setRoomsData] = useState({});

  
 

  useEffect(() => {
    if (refresh !== 0) {
      fetchDisp();
    }
  }, [refresh])

  useEffect(() => {
    const loggedIn = sessionStorage.getItem("user_login");
    if (dataDisp) {
      const dataResponse = dataDisp as any
      setRoomsData(dataResponse);
      setIsErrorModalOpen(false);
      if (loggedIn) {
        if (!errorMessage){
        setOpenModalReservation(true);
        } else {
          setIsErrorModalOpen(true);
        }
      }
      else {
        setOpenModalLogin(true);
      }
    }
    if (errorDisp) {
      const errorResponse = errorDisp as any
      if (errorResponse.code) {
        switch (errorResponse.code) {
          case "530":
            setErrorMessage("No hay habitaciones disponibles para tu busqueda");
            setIsErrorModalOpen(true);
            break;
          default:
            setErrorMessage("No se pudo realizar la consulta por favor intente de nuevo más tarde");
            setIsErrorModalOpen(true);
            break;
        }
      } else {
        setErrorMessage("No se pudo realizar la consulta por favor intente de nuevo más tarde");
        setIsErrorModalOpen(true);
      }
    }
  }, [dataDisp, errorDisp])

  // Definir el tipo de contingente
  interface Contingente {
    from: string;
    to: string;
  }

  const handleConsultAvailability = async() => {
    

    console.log('logueado consultate la disponibilidad');
    
    setErrorMessage("");
    setIsErrorModalOpen(false);
  
    const hotel_disp = sessionStorage.getItem("selected_hotel");
    let date_from_disp = sessionStorage.getItem("start_disp") || ''; // Manejar null
    let date_to_disp = sessionStorage.getItem("end_disp") || ''; // Manejar null
    const guest_disp = sessionStorage.getItem("total_disp");

  
    // Verificar que las fechas no son null o cadenas vacías
    if (date_from_disp && date_to_disp) {
      const dateFrom = new Date(`${date_from_disp}T00:00:00`);
      const dateTo = new Date(`${date_to_disp}T00:00:00`);

      let encontroContingente = false;

      // ver caso de los contigentes
      if(fechasContingentes.length > 0){
         
          let firstContingente: FechasContingente | null = null;
          let lastContingente: FechasContingente | null = null;
  
          // Iterar sobre los contingentes para verificar si alguna fecha está dentro del rango
          fechasContingentes.forEach((contingente) => {
            const contingenteFrom = new Date(contingente.fecha_inicio);
            const contingenteTo = new Date(contingente.fecha_fin);
  
            // Si la fecha de inicio está dentro de este contingente
            if (dateFrom >= contingenteFrom && dateFrom <= contingenteTo) {
              firstContingente = contingente; // Guardar el primer contingente encontrado
            }
  
            // Si la fecha de fin está dentro de este contingente
            if (dateTo >= contingenteFrom && dateTo <= contingenteTo) {
              lastContingente = contingente; // Guardar el último contingente encontrado
            }
          });

          //adapto las fechas en caso de que una de las fechas no se encuentre dentro de un contingente
          if(firstContingente !== null || lastContingente !== null){
            fechasContingentes.forEach((contingente) => {
              const contingenteFrom = new Date(contingente.fecha_inicio);
              const contingenteTo = new Date(contingente.fecha_fin);
              if(firstContingente === null){
                if (lastContingente !== null && new Date(lastContingente.fecha_fin) >= contingenteFrom && new Date(lastContingente.fecha_fin) <= contingenteTo) {
                  firstContingente = contingente; 
                }
              }else{
                if (firstContingente !== null && new Date(firstContingente.fecha_inicio) >= contingenteFrom && new Date(firstContingente.fecha_inicio) <= contingenteTo) {
                  lastContingente = contingente;
                }
              }
            });
          }
  
          // Verificamos que se encontraron los contingentes correspondientes
          //caso que se encontron los contigentes
          if ( (firstContingente !== null && lastContingente !== null)) {
            console.log('se encontraron dentro de 1 o 2 contingentes');
            // Forzar el tipo 'FechasContingente' para evitar el error 'never'
            firstContingente  = firstContingente as FechasContingente;
            lastContingente = lastContingente as FechasContingente;
            // Adaptar las fechas al rango completo entre el primer y el último contingente
            date_from_disp = firstContingente.fecha_inicio;
            date_to_disp = lastContingente.fecha_fin;

            encontroContingente = true;
          }else{
            date_from_disp = sessionStorage.getItem("start_disp")!;
            date_to_disp = sessionStorage.getItem("end_disp")!;
          }

          if(encontroContingente){
            // Mostrar el mensaje de error indicando la adaptación
            setErrorMessage("Se adaptaron las fechas en función de los contingentes habilitados. Consulte las fechas planificadas.");
            setIsErrorModalOpen(true);

            //Guardar las fechas adaptadas en sessionStorage
            sessionStorage.setItem("start_date", date_from_disp);
            sessionStorage.setItem("end_date", date_to_disp);
            sessionStorage.setItem("start_disp", date_from_disp);
            sessionStorage.setItem("end_disp", date_to_disp);
            sessionStorage.setItem("selected_date", `${date_from_disp} - ${date_to_disp}`);
  
            // Marcar que las fechas han sido ajustadas
            sessionStorage.setItem("dates_adjusted", "true");
  
            // Mostrar el mensaje de error indicando la adaptación
            setErrorMessage("Se adaptaron las fechas en función de los contingentes habilitados. Consulte las fechas planificadas.");
            
            setRefresh(refresh + 1);
          }
      }
      
      //veo caso de dia minimos si no se encontraron contigentes
      if(!encontroContingente){
        console.log('caso dias minimos')
        try {
          const diasMinimos = await obtenerDiasMinimos();

          const diasDeReservas = obtenerDiasDeLasReservas();

          console.log("dias de reservas", diasDeReservas);
          console.log("dias minimos", diasMinimos);

          if (diasDeReservas < diasMinimos) {
            setErrorMessage(`La estadia minima para la fecha seleccionada es ${diasMinimos} días.`);
            setIsErrorModalOpen(true);
            return
          }

        } catch (error) {
          setErrorMessage("Error al consultar la disponibilidad. Por favor, inténtelo de nuevo.");
          setIsErrorModalOpen(true);
          return
        }
        setRefresh(refresh + 1);

      }

    } else {
      setErrorMessage("Fechas no válidas");
      setIsErrorModalOpen(true);
    }
  };
  
  




  const renderSidebar = () => {

    const handleReservation = async () => {
      try {
        // Realiza la llamada a la API para verificar el semaphore_status
        const response = await fetch(`${config.backend_url}/authe/token`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'SetiaAuthorization': `${sessionStorage.getItem('user_token')}`,
          },
        });

        if (!response.ok) {
          throw new Error('Error en la autenticación.');
        }

        const data = await response.json();

        // Verifica el valor de semaphore_status en la respuesta
        const semaphoreStatus = data.semaphore_status;
        sessionStorage.setItem("semaphore", semaphoreStatus);

        if (semaphoreStatus === 2) {
          // Almacena los datos de la reserva en sessionStorage
          sessionStorage.setItem("roomsData", JSON.stringify(roomsData));

          // Redirige a la página de distribución de habitaciones
          router('/rooms-distribution');
        } else {
          // Muestra el mensaje de error si la cuenta requiere documentación
          setErrorMessage("Tu cuenta requiere que subas documentación. Por favor, hazlo desde: Inicio > Alerta de documentación pendiente.");
          setIsErrorModalOpen(true);
        }

      } catch (error) {
        console.error("Error al verificar el estado del semaphore:", error);
        setErrorMessage("Ocurrió un error al verificar el estado de tu cuenta. Por favor, inténtalo de nuevo.");
        setIsErrorModalOpen(true);
      }
    };

    const handleCloseModalReservation = () => {
      setOpenModalReservation(false);
    }
    const handleCloseModalLogin = () => {
      setOpenModalLogin(false);
    }
    const handleCloseErrorModal = () => {
      if (errorMessage === "Tu cuenta requiere que subas documentación. Por favor, hazlo desde: Inicio > Alerta de documentación pendiente.") {
        router('/account-documents');
      } else if (errorMessage === "Se adaptaron las fechas en función de los contingentes habilitados. Consulte las fechas planificadas.") {

        handleReservation();

      } else {
        setIsErrorModalOpen(false);
       
      }
    }

    return (
      <div className="listingSectionSidebar__wrap shadow-xl">
        {/* PRICE */}
        <div className="flex justify-between">
          <span className="text-3xl font-semibold">
            Tu Busqueda:
            {/* <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
              /night
            </span> */}
          </span>
        </div>

        {/* FORM */}
        <form className="flex flex-col border border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <StayDatesRangeInput className="flex-1 z-[11]" />
          <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
          <GuestsInput className="flex-1" />
        </form>
        {/* SUBMIT */}
        <ButtonPrimary disabled={loadingDisp} onClick={handleConsultAvailability}>Consultar Disponibilidad</ButtonPrimary>
        <ReservationModal
          message="Tenemos habitaciones disponibles! Reserva ahora!"
          isReservationModalOpen={openModalReservation}
          handleReservationModalClose={handleCloseModalReservation}
          handleReservation={handleReservation}
          title="Desea Reservar?"
        />
        <LoginModal
          isLoginModalOpen={openModalLogin}
          handleLoginModalClose={handleCloseModalLogin}
        />
        <ErrorModal
          message={errorMessage}
          isModalOpen={isErrorModalOpen}
          handleModalClose={handleCloseErrorModal}
        />

      </div>
    );
  };

  return (
    <div className="nc-ListingStayDetailPage">
      {/*  HEADER */}
      <header className="rounded-md sm:rounded-xl">
        <div className="relative grid grid-cols-3 sm:grid-cols-4 gap-1 sm:gap-2">
          <div
            className="col-span-2 row-span-3 sm:row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer "
            onClick={handleOpenModalImageGallery}
          >
            <img
              className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
              src={PHOTOS[0]}
              alt=""
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
            />
            <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
          </div>
          {PHOTOS.filter((_, i) => i >= 1 && i < 5).map((item, index) => (
            <div
              key={index}
              className={`relative rounded-md sm:rounded-xl overflow-hidden ${index >= 3 ? "hidden sm:block" : ""
                }`}
            >
              <div className="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5">
                <img
                  className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                  src={item || ""}
                  alt=""
                  sizes="400px"
                />
              </div>

              {/* OVERLAY */}
              <div
                className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                onClick={handleOpenModalImageGallery}
              />
            </div>
          ))}

          <button
            className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 hover:bg-neutral-200 z-10"
            onClick={handleOpenModalImageGallery}
          >
            <Squares2X2Icon className="w-5 h-5" />
            <span className="ml-2 text-neutral-800 text-sm font-medium">
              Ver todas las fotos
            </span>
          </button>
        </div>
      </header>

      {/* MAIN */}
      <main className=" relative z-10 mt-11 flex flex-col lg:flex-row ">
        {/* CONTENT */}
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
          {renderSection1()}
          {renderSection2()}
          {renderSection3()}
          {renderSection4()}
          {renderSection7()}
          {renderSection8()}
        </div>

        {/* SIDEBAR */}
        <div className="hidden lg:block flex-grow mt-14 lg:mt-0">
          <div className="sticky top-28">{renderSidebar()}</div>
        </div>
      </main>
    </div>
  );
};

export default function ListingStayDetailPage() {
  return (
    <DetailPagetLayout>
      <StayDetailPageContainer />
    </DetailPagetLayout>
  );
}
